import { render, staticRenderFns } from "./NavStatsCard.vue?vue&type=template&id=356ec390&"
import script from "./NavStatsCard.vue?vue&type=script&lang=js&"
export * from "./NavStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports